import React, { useState } from 'react';
import { Paper } from '@mui/material';

import PlanDetail from '../../components/plannen/PlanDetail';

const PagePlan: React.FC = () => {
  const [planNaam, setPlanNaam] = useState('');
  const [planOmschrijving, setPlanOmschrijving] = useState('');
  // const { id } = useParams<{ id: string }>(); // in case we want to fetch plan by id in the future

  return (
    <>  
      <header className="app-header container">
        <h1>{planNaam}</h1>
        <p className="header-sub-title">{planOmschrijving}</p>
      </header>

      <div className="container content plan-detail">
        <Paper sx={{ width: '100%', padding: '50px 20px', margin: '0px auto' }}>
          <PlanDetail setPlanNaam={setPlanNaam} setPlanOmschrijving={setPlanOmschrijving} />
        </Paper>
      </div>
    </>
  );
};

export default PagePlan;
